import styled from 'styled-components';

import { Page } from '@zillow/constellation';

export const StyledInquiryContact = styled(Page)`
  margin-top: 32px - 8px;
  background-color: white;
  @media (min-width: 768px) {
    margin-top: 64px - 8px;
    padding: 32px;
  }

  .HR {
    margin: 16px 0;
  }
`;
